import { useCallback } from "react";
import { useAPIAction, UserManagementApi } from "melco-shared-logic";

export interface UserManagementApiDeviceDeleteDeviceRequest {
  id?: string;
  productCode: string;
  deviceId: string;
}

export const useUserDeviceLogout = () => {
  const [logoutDevice] = useAPIAction(
    UserManagementApi,
    async (
      api,
      devicesLogoutActionDetails: UserManagementApiDeviceDeleteDeviceRequest
    ) => {
      console.log(devicesLogoutActionDetails);

      const data = await api.deviceDeleteDevice(devicesLogoutActionDetails);

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    {
      translationPrefix: "users.tabs.devices.actions.logout",
    }
  );

  return useCallback(
    async (
      devicesLogoutActionDetails: UserManagementApiDeviceDeleteDeviceRequest
    ) => {
      //const successfullyCancelled: string = "";

      try {
        await logoutDevice(devicesLogoutActionDetails);
        // successfullyCancelled.push(blankId);
      } catch (e) {
        // error handling is already done in useAPIAction
      }

      return devicesLogoutActionDetails.deviceId;
    },
    [logoutDevice]
  );
};
